/* eslint-disable react/prop-types */
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Dialog from 'components/DialogWrapper/DialogWrapper';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Divider from '@material-ui/core/Divider';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import Button from 'components/Button/Button';
import DialogHeader from 'components/DialogHeader/DialogHeader';
import useStyles from './ProjectDeleteConfirmationDialogStyles';
import Icon from '@mdi/react';
import { mdiDelete, mdiInformation, mdiMap, mdiSchoolOutline } from '@mdi/js';
import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';
import TextInput from 'components/TextInput/TextInput';

function ProjectDeleteConfirmationDialogLayout(props) {
  const { project, onClose, open, handleDelete } = props;
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation('common');

  const upSm = useMediaQuery(theme.breakpoints.up('sm'));

  const [confirmationText, setConfirmationText] = useState('');

  const disableDelete = confirmationText !== project?.projectKey;

  return (
    <Dialog
      aria-labelledby="orientation-fill-dialog"
      classes={{ paper: classes.dialogPaper }}
      disableBackdropClick
      fullScreen={!upSm}
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={onClose}
    >
      <DialogHeader
        icon={<Icon path={mdiInformation} size={1} className={classes.icon} />}
        onClose={onClose}
        title={`Poista projekti ${project?.projectKey} - ${project?.name}`}
      />

      <DialogContent className={classes.dialogContent}>
        <Grid container spacing={1} className={classes.gridContainer}>
          <Grid item xs={12} justifyContent="flex-start">
            <Typography>
              Haluatko varmasti poistaa projektin{' '}
              <em>{`${project?.projectKey} - ${project?.name}`}</em> sekä sen alaprojektit?
              Vahvistaaksesi poiston, täytä projektin avain alla olevaan
              kenttään.
            </Typography>
            <br />
            <Typography>
              Projektin laskut siirretään isäntäprojektille.
            </Typography>
          </Grid>
          <Grid container item>
            <TextInput
              label="Projektin avain"
              shrink
              placeholder={project?.projectKey || ''}
              fullWidth
              value={confirmationText}
              onChange={(e) => setConfirmationText(e.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <Divider />
      <DialogActions className={classes.dialogActions}>
        <Button
          className={classes.actionBtn}
          onClick={() => handleDelete()}
          color="danger"
          disabled={disableDelete}
        >
          <Icon path={mdiDelete} size={1} />
          Poista projekti
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ProjectDeleteConfirmationDialogLayout.defaultProps = {};

ProjectDeleteConfirmationDialogLayout.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  project: PropTypes.object,
};

export default ProjectDeleteConfirmationDialogLayout;
